export default __webpack_public_path__ + "static/media/full-background.f180c38d.svg";